module.exports = __webpack_public_path__ + "static/img/1.f2ebe50.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/management/1.png
// module id = LReI
// module chunks = 7